// extracted by mini-css-extract-plugin
export var addButton = "_f9-0";
export var border = "_f9-8";
export var check = "_f9-h";
export var danger = "_f9-6";
export var dropdownContainer = "_f9-1";
export var editModalBody = "_f9-j";
export var footerContainer = "_f9-i";
export var fullWidth = "_f9-a";
export var hide = "_f9-9";
export var icon = "_f9-3";
export var input = "_f9-7";
export var inputFlex = "_f9-b";
export var inputWrapper = "_f9-c";
export var manualFocus = "_f9-5";
export var optionButton = "_f9-4";
export var pillWrapper = "_f9-e";
export var pointer = "_f9-2";
export var showOverflow = "_f9-f";
export var tagsFlex = "_f9-d";
export var xButton = "_f9-g";